import { render } from "./NodeDetail.vue?vue&type=template&id=b4985b96&scoped=true&ts=true"
import script from "./NodeDetail.vue?vue&type=script&lang=ts"
export * from "./NodeDetail.vue?vue&type=script&lang=ts"

import "./NodeDetail.vue?vue&type=style&index=0&id=b4985b96&lang=scss&scoped=true"
import "./NodeDetail.vue?vue&type=style&index=1&id=b4985b96&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4985b96"]])

export default __exports__